import { Routes, Route } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import React from 'react';
import './index.css';
import Home from './pages/HomePage'
import Privacy from './pages/PrivacyPage';
import Terms from "./pages/TermsPage"
import Cookies from './pages/CookiesPage';
import Subprocessors from './pages/SubprocessorsPage';
import Security from './pages/SecurityPage';
import PrivacyRequests from './pages/PrivacyRequestsPage';
import Contact from "./pages/ContactPage"
import About from './pages/AboutPage';
import Registration from "./pages/RegistrationPage";
import Pricing from './pages/PricingPage';
import Faq from "./pages/FaqPage";
import Blog from "./pages/BlogPage";
import Changelog from "./pages/ChangelogPage";


const WebRoutes = () => (
     <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>}></Route>
          <Route path="/pricing" element={<Pricing/>}></Route>
          <Route path="/faq" element={<Faq/>}></Route>
          <Route path="/blog" element={<Blog/>}></Route>
          <Route path="/changelog" element={<Changelog/>}></Route>
          <Route path="/privacy" element={<Privacy/>}></Route>
          <Route path="/terms" element={<Terms/>}></Route>
          <Route path="/cookies" element={<Cookies/>}></Route>
          <Route path="/subprocessors" element={<Subprocessors/>}></Route>
          <Route path="/security" element={<Security/>}></Route>
          <Route path="/privacy-requests" element={<PrivacyRequests/>}></Route>
          <Route path="/contact" element={<Contact/>}></Route>
          <Route path="/about" element={<About/>}></Route>
          <Route path="/registration" element={<Registration/>}></Route>
        </Routes>
      </BrowserRouter>
);

export default WebRoutes;
